import { createStore } from 'vuex'
import cachedData from './modules/cachedData'
import userRelated from './modules/userRelated'
import alert from './modules/alert'

export default createStore({
  modules: { cachedData, userRelated, alert }
})
